import styled from 'styled-components'

export const StyledInput = styled.input`
  margin-right: 32px !important;
`